var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41406 14L5.67363 14C6.7971 16.3649 9.2076 18 12 18C14.9742 18 17.5151 16.1452 18.5291 13.5291L16 11L24 11V19L21.518 16.518C19.6135 19.796 16.0641 22 12 22C6.96489 22 2.71992 18.617 1.41406 14Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3264 8H22.5859C21.2801 3.38299 17.0351 0 12 0C7.93587 0 4.38652 2.20403 2.48203 5.48203L1.90735e-06 3L1.90735e-06 11L8 11L5.47085 8.47085C6.4849 5.85484 9.02584 4 12 4C14.7924 4 17.2029 5.63505 18.3264 8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/Refresh.9a8a5e7ce1ba015f9fa4e1948cd778db.svg";
export { ForwardRef as ReactComponent };